var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("span", { staticClass: "mso mso-36px" }, [
                          _vm._v(_vm._s(_vm.iconName)),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [_vm._t("text-content")],
            2
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  staticClass: "button",
                  class: [{ tooltip: _vm.okTooltip !== "" }, _vm.okClass],
                  attrs: { "data-tooltip": _vm.okTooltip },
                  on: {
                    click: function ($event) {
                      return _vm.ok()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.okText) + " ")]
              ),
              _vm.showCancel
                ? _c(
                    "button",
                    {
                      staticClass: "button",
                      class: [
                        { tooltip: _vm.cancelTooltip !== "" },
                        _vm.cancelClass,
                      ],
                      attrs: { "data-tooltip": _vm.cancelTooltip },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.cancelText) + " ")]
                  )
                : _vm._e(),
              _vm.showClose
                ? _c(
                    "button",
                    {
                      staticClass: "button",
                      class: [
                        { tooltip: _vm.closeTooltip !== "" },
                        _vm.closeClass,
                      ],
                      attrs: { "data-tooltip": _vm.closeTooltip },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.closeText) + " ")]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }